import React from 'react';
import { Link } from 'react-router-dom';
import Pretive from '../media/Preative.svg';

const Footer = () => (
  <footer className="bg-[#0d0018] text-gray-300">
    <div className="container mx-auto px-[5%] py-12">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <img src={Pretive} alt="Preative Solutions logo" className="h-14 mb-4" />
          <p className="text-sm text-gray-400 leading-relaxed max-w-xs">
            Building AI-native products for the future of education, from India for the world.
          </p>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-4 text-sm tracking-wide uppercase">Company</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about" className="hover:text-purple-400 transition-colors">About</Link></li>
            <li><Link to="/products" className="hover:text-purple-400 transition-colors">Products</Link></li>
            <li><Link to="/careers" className="hover:text-purple-400 transition-colors">Careers</Link></li>
            <li><Link to="/contact" className="hover:text-purple-400 transition-colors">Contact</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-4 text-sm tracking-wide uppercase">Products</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/products/gyanspark" className="hover:text-purple-400 transition-colors">GyanSpark</Link></li>
            <li><Link to="/products/gyanbeej" className="hover:text-purple-400 transition-colors">Gyanbeej</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 mt-10 pt-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-gray-500">
        <p>&copy; {new Date().getFullYear()} Preative Solutions. All rights reserved.</p>
        <p>Incubated at SIIC, IIT Kanpur</p>
      </div>
    </div>
  </footer>
);

export default Footer;
